import { objectHasKeys } from "../helpers/util";

import { Tracking } from "../helpers/enums";
import {
  trackPageView,
  trackEvent,
  getGlobalTrackingVars,
  abandonBrowseIsActive,
} from "./helpers";

export const pageTracking = (page_code?: string) => {
  const eventData = {};
  if (page_code) {
    eventData["page_code"] = page_code;
  }
  trackPageView({ eventData });
};

export const componentTracking = () => {
  const components = document.querySelectorAll<HTMLElement>(
    "[data-gtm-event-track]"
  );

  if (!components) {
    return;
  }

  components.forEach((component) => {
    const dataset = component.dataset ?? {};
    if (dataset?.gtmEventTrack === "1" && dataset?.gtmEventValue != "") {
      const containsAnchor = component.querySelector("a");

      const sendTrackEvent = () =>
        trackEvent({ eventName: dataset.gtmEventValue });

      if (containsAnchor) {
        containsAnchor.addEventListener("click", () => {
          sendTrackEvent();
        });
      } else if (
        component.nodeName === "A" ||
        component.nodeName === "BUTTON"
      ) {
        component.addEventListener("click", () => {
          sendTrackEvent();
        });
      }
    }
  });
};

export const loginTracking = () => {
  const loginVars = window["trackingVarsLogin"] ?? {};

  if (objectHasKeys(loginVars)) {
    trackEvent({ eventName: Tracking.LOGIN, eventData: loginVars });
  }
};

export const registerTracking = () => {
  const registerVars = window["trackingVarsRegister"] ?? {};

  if (objectHasKeys(registerVars)) {
    trackEvent({ eventName: Tracking.SIGN_UP, eventData: registerVars });
  }
};

function decodeHtml(html) {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

export const abandonBrowseTracking = () => {
  setTimeout(() => {
    if (abandonBrowseIsActive()) {
      const cityPageVars = window?.["abandonBrowseVarsCity"];
      const hotelPageVars = window?.["abandonBrowseVarsHotel"];
      const abandonBrowseVarsGlobal = window?.["abandonBrowseVarsGlobal"];

      let name = "";
      let sku = "";
      let image_path = "";
      let categories = "";
      let description = "";
      let brand = "";

      if (cityPageVars) {
        const {
          product_brand,
          product_categories,
          product_description,
          product_image_path,
        } = window["abandonBrowseVarsCity"];

        name = "";
        sku = "";
        image_path = product_image_path;
        categories = product_categories;
        description = product_description;
        brand = product_brand;
      } else if (hotelPageVars) {
        const {
          product_brand,
          product_categories,
          product_description,
          product_image_path,
          product_name,
          product_sku,
        } = window["abandonBrowseVarsHotel"];

        name = product_name;
        sku = product_sku;
        image_path = product_image_path;
        categories = product_categories;
        description = product_description;
        brand = product_brand;
      }

      const viewed_product = {
        product_name: decodeHtml(name),
        product_sku: decodeHtml(sku),
        product_price: 0,
        product_url: window.location.href,
        product_image_path: image_path,
        product_categories: decodeHtml(categories),
        product_currency: getGlobalTrackingVars()?.display_currency,
        product_brand: brand,
        product_description: decodeHtml(description),
        browsing_language: getGlobalTrackingVars()?.browsing_language,
      };

      window["dmPt"]("track", viewed_product);

      if (abandonBrowseVarsGlobal?.email_address) {
        window["dmPt"]("identify", abandonBrowseVarsGlobal?.email_address);
      }
    }
  }, 2000);
};
